import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Dictionary } from '@ngrx/entity';

import { Taxonomy } from '@core/models/taxonomy.model';
import * as fromActions from '@core/core-store/locations-nested/locations-nested.actions';

export interface State extends EntityState<Taxonomy> {}

export const adapter: EntityAdapter<Taxonomy> =
  createEntityAdapter<Taxonomy>({
    selectId: location => location.id
});

export const initialState: State = {
  ...adapter.getInitialState(),
};

const locationsNestedReducer = createReducer(
  initialState,
  on(fromActions.locationsNestedCollectionAddMany, (state, {locationsNested}) => (
    adapter.addMany(locationsNested, state)
  )),
);

export function reducer(state: State | undefined, action: Action) {
  return locationsNestedReducer(state, action);
}

export const getIds = adapter.getSelectors().selectIds;
export const getEntities = adapter.getSelectors().selectEntities;
export const getAll = adapter.getSelectors().selectAll;
export const getTotal = adapter.getSelectors().selectTotal;

export const getEntityById = (entities: Dictionary<Taxonomy>, {id}) => entities[id];
export const getEntitiesById = (entities: Dictionary<Taxonomy>, {ids}) => ids.map(id => entities[id]);

